import Flickity from 'flickity-imagesloaded';
import $ from 'jquery';
import _ from 'lodash';

class Slider {
    constructor(selector, options) {
        this.el = selector;
        this.init(options);
        this.$body = $('body');
    }

    goTo(index) {
        this.flkty.select(index)
    }

    init(options) {
        this.flkty = new Flickity(this.el, options);

        setTimeout(() => {
            this.flkty.resize();
        }, 500);

        this.flkty.on('resize', _.debounce(() => {
            this.$body.trigger('flkty:updated');
        }, 100));

        this.flkty.on('settle', () => {
            this.$body.trigger('flkty:updated');
        })
    }
}

module.exports = Slider;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/slider.js